module.exports = __webpack_public_path__ + "static/img/banner4.e8501e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clinic/banner4.png
// module id = 1oWf
// module chunks = 1